import { createAction, createSlice } from '@reduxjs/toolkit';

export const approvalInitialState = {
    showListData: [],
    loaderData: {
        isLoading: false,
        mssg: ''
    },
    approvalToggleState: '',
    approvalData: {
        categoryData: [],
        specialityData: [],
        showListData: [],
        showListResponse: [],
        engagementStatusData: [],
        approvalHistoryData: [],
        approvalHistoryPayloadData: {},
        engagementsList: [],
        showListPayloadData: {},
        approvalEngagementType: '',
        wsfaData:[],
        isApproved:false,
    },
    approvalStatusData: {
        engagementUser: {},
        engagementPartyApprovalList: []
    },
    approvalStatusResponseData: {}, 
    approvalCustomerListResponseData: {},
    approvalsLandingFilterData: {}, 
    approvalsShowListsFilterData: {},
    showListFilterClicked:false,
    userSelectedShowListFilters:{},
    appliedCampaignFilter: {}, // Stores selected campaign filter from CampaignFilter component
    categoryPaginationState: {
        pageNo: 1,
        pageSize: 10
    },
    categoryTotalCount: 0, // Total number of category records from API
    specialityPaginationState: {
        pageNo: 1,
        pageSize: 10
    },
    specialityTotalCount: 0, // Total number of speciality records from API
    shouldNavigateToApproval: false, // Flag to trigger navigation after mark as complete
}

export const fetchApprovalDataCreator = createAction<any>(
    'APPROVAL_MODULE/FETCH_APPROVAL_DATA',
);
export const fetchApprovalDataCreatorTypeName =
    fetchApprovalDataCreator(null).type;

export const fetchApprovalCustomerListDataCreator = createAction<any>(
    'APPROVAL_MODULE/FETCH_APPROVAL_CUSTOMER_LIST_DATA',
);
export const fetchApprovalCustomerListDataCreatorTypeName =
    fetchApprovalCustomerListDataCreator(null).type;

export const fetchApprovalsLandingFiltersCreator = createAction<any>(
  'CAMP_APPROVALS/LANDING_FILTERS',
);
export const fetchApprovalsLandingFilterDataTypesName = fetchApprovalsLandingFiltersCreator(null).type;    

export const fetchApprovalsShowListFiltersCreator = createAction<any>(
  'CAMP_APPROVALS/LANDING_FILTERS',
);
export const fetchApprovalsShowListFilterDataTypesName = fetchApprovalsShowListFiltersCreator(null).type;    

export const fetchMarkCampaignAsCompleteCreator = createAction<any>(
    'CAMP_APPROVALS/MARK_CAMPAIGN_AS_COMPLETE',
);
export const fetchMarkCampaignAsCompleteCreatorTypeName = fetchMarkCampaignAsCompleteCreator(null).type;    

const approvalStateHandler = createSlice({
    name: 'APPROVAL_HANDLER',
    initialState: approvalInitialState,
    reducers: {
        setShowListData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                showListData: payload,
            };
        },
        setLoaderData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                loaderData: payload,
            };
        },
        setApprovalData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalData: { ...prevState.approvalData, ...payload },
            };
        },
        setApprovalStatusData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalStatusData: {...prevState.approvalStatusData, ...payload},
            };
        },
        setApprovalStatusResponseData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalStatusResponseData: payload,
            };
        },
        setApprovalCustomerListResponseData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalCustomerListResponseData: payload,
            };
        },
        setApprovalToggleState: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalToggleState: payload,
            };
        },
        setApprovalwsfaCodes: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalwsfaCodes: payload,
            };
        },
        setApprovalsLandingFilterData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalsLandingFilterData: payload,
            };
        },
        setApprovalsShowListsFilterData: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                approvalsShowListsFilterData: payload,
            };
        },
        setUserSelectedShowListFilters: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                userSelectedShowListFilters: payload,
            };
        },
        setShowListFilterClicked: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                showListFilterClicked: payload,
            };
        },
        setAppliedCampaignFilter: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                appliedCampaignFilter: payload,
            };
        },
        setCategoryPaginationState: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                categoryPaginationState: payload,
            };
        },
        setCategoryTotalCount: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                categoryTotalCount: payload,
            };
        },
        setSpecialityPaginationState: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                specialityPaginationState: payload,
            };
        },
        setSpecialityTotalCount: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                specialityTotalCount: payload,
            };
        },
        setShouldNavigateToApproval: (prevState, action) => {
            const { payload } = action;
            return {
                ...prevState,
                shouldNavigateToApproval: payload,
            };
        },
    }
})

export const approvalStateActions =
    approvalStateHandler.actions;
export const approvalStateReducer =
    approvalStateHandler.reducer;